import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';

export const BannerAdsBox = styled(Box)`
  @media print {
    display: none;
  }
`;
